import {isNotNil, uniq} from 'ramda';

import {RateMatrixResponseBody, VehicleFinancingBalloonPayment} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {RateMatrixCellData} from '../types/RateMatrixCellData';
import {RateMatrixValue} from '../types/RateMatrixValue';
import {buildRateMatrixCellKey} from './buildRateMatrixCellKey';

export function deserializeRateMatrix(
  rateMatrix: RateMatrixResponseBody,
  defaultBalloonPayment: VehicleFinancingBalloonPayment | Nullish
): RateMatrixValue {
  const cells: Record<string, RateMatrixCellData> = {};

  rateMatrix.cells.forEach((cell) => {
    const key = buildRateMatrixCellKey({
      term: cell.term,
      downPayment: cell.downPayment,
      balloonBracket: cell.balloonPayment,
    });
    cells[key] = {nominalRate: cell.nominalRate, apr: cell.apr};
  });

  const bracketsFromCells = rateMatrix.cells.map((cell) => cell.balloonPayment).filter(isNotNil);
  const bracketsFromDefault = isNotNil(defaultBalloonPayment) ? [defaultBalloonPayment] : [];
  const availableBalloonBrackets = uniq([...bracketsFromCells, ...bracketsFromDefault]).sort(
    (left, right) => left - right
  );

  return {
    availableTerms: rateMatrix.availableTerms,
    cells,
    availableBalloonBrackets,
    defaultBalloonPayment: defaultBalloonPayment ?? null,
  };
}
